import React from 'react';
import PropTypes from 'prop-types';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import { GENDERS } from 'dpl/shared/constants/breeder_app';

import ParentDogCard from '../shared/ParentDogCard';

export default function ParentDogsMobileMenu({
  isOpen,
  closeModal,
  parentDogs
}) {
  return (
    <FixedTooltipPortal
      className="ParentDogsMobileMenu ph5 bg-white no-scrollbars b--transparent"
      isVisible={isOpen}
      style={{ maxHeight: '85vh' }}
      onCloseClick={() => closeModal()}
    >
      <h4 className="font-24 lh-title pt2 mb6 w-90 mr2">Parent dogs</h4>
      {parentDogs.map(dog => (
        <div key={dog.id} className="mb4">
          <ParentDogCard dog={dog} isInnerTooltip />
        </div>
      ))}
    </FixedTooltipPortal>
  );
}

ParentDogsMobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  parentDogs: PropTypes.arrayOf(
    PropTypes.shape({
      breed_name: PropTypes.string,
      breed_slug: PropTypes.string,
      description: PropTypes.string,
      gender: PropTypes.oneOf(Object.values(GENDERS)),
      health_testing: PropTypes.shape({
        title: PropTypes.string,
        documented_health_tests: PropTypes.arrayOf(PropTypes.string)
      }),
      health_tier_title: PropTypes.string,
      health_test_results_public: PropTypes.bool,
      health_test_results: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          description: PropTypes.string,
          health_test_id: PropTypes.number,
          health_test_name: PropTypes.string,
          health_test_result_documents: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number,
              is_file: PropTypes.bool,
              name: PropTypes.string,
              url: PropTypes.string
            })
          )
        })
      ),
      id: PropTypes.number,
      name: PropTypes.string,
      profile_photo_url: PropTypes.string
    }).isRequired
  )
};

ParentDogsMobileMenu.defaultProps = {
  parentDogs: []
};
